import { select } from "redux-saga/effects";
import { RootState } from "./rootReducer";

export const BASE_URL = 'https://kerma.umn.ac.id/the-endurance/';
// export const BASE_URL = 'http://localhost/Kerma-Back-End/web/';
export const BASE_DOWNLOAD = `${BASE_URL}uploads/`;
export const DOWNLOAD_DOCUMENT = `${BASE_DOWNLOAD}document/`;
export const DOWNLOAD_MONEV = `${BASE_DOWNLOAD}monev/`;

/**
 * Execute API call with method get
 * @param url 
 * @param token 
 * @returns 
 */
export const apiGet = (url: string, token: string) => {
  return fetch(url, {
    mode: 'cors',
    method: 'GET',
    headers: {
      'Authorization': `Basic ${btoa(`${token}:`)}`,
      'Content-Type': 'application/json; charset=utf-8'
    },
  });
};

/**
 * Execute API call with method post
 * @param url 
 * @param token 
 * @param data 
 * @returns promise
 */
export const apiPost = (url: string, token: string, data: any) => {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': `Basic ${btoa(`${token}:`)}`,
      'Content-Type': "application/json; charset=UTF-8"
    },
    body: JSON.stringify(data),
  });
};

/**
 * Execute API for file upload
 * @param url 
 * @param token 
 * @param data 
 * @returns promise
 */
export const apiUpload = (url: string, token: string, data: any) => {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': `Basic ${btoa(`${token}:`)}`,
    },
    body: data,
  });
};

/**
 * Execute API call with method put
 * @param url 
 * @param token 
 * @param data 
 * @returns promise
 */
export const apiPut = (url: string, token: string, data: any) => {
  return fetch(url, {
    method: 'PUT',
    headers: {
      'Authorization': `Basic ${btoa(`${token}:`)}`,
      'Content-Type': "application/json; charset=UTF-8"
    },
    body: JSON.stringify(data),
  });
};

/**
 * Convert object into url parameters.
 * @param object 
 * @returns ?param1=value&param2=value
 */
export const objectToParams = (object: any): string => {
  let str = "";
  for (var key in object) {
    if (str !== "") {
        str += "&";
    }
    str += key + "=" + encodeURIComponent(object[key]);
  }
  return "?" + str;
}

/**
 * Convert params into object.
 * @param url example: http://something.com/?param1=value&param2=value
 * @returns object from params
 */
export const paramsToObject = (url: string): any => {
  try {
    return JSON.parse('{"' + decodeURI(url.substring(1)).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
  } catch (ex) {
    return null;
  }
}

export function* retrieveToken() {
  const tokenState = (state: RootState) => state.authorization.token;
  const tokenAuth: string = yield select(tokenState);
  const token: string = `${tokenAuth}:`;
  return token;
}